<header class="login-header">
  <a class="login-header__brand" (click)="back()">
    <img src="assets/images/logo-airlines-blue.svg" class="login-header__logo" alt="Logo da Latam Azul">
  </a>
</header>

<main class="external-login">
  <section class="container" aria-labelledby="external-login-title">
    <img class="external-illustration" src="assets/images/login.png" alt="">

    <p class="access-eyebrow">Tripulantes Externos</p>
    <h1 id="external-login-title" class="welcome-text">Bem-vindo ao Passe Livre</h1>

    <p class="external-login_text">Login para usuários externos</p>

    <form class="login-form" [formGroup]="loginForm">
      <div class="form-field">
        <input type="text" class="anac_code" placeholder="Código ANAC"
          aria-label="Código ANAC" formControlName="user">

        @if (submited && loginForm.controls.user.errors?.required) {
          <app-error-form>
            Informe o Código ANAC.
          </app-error-form>
        }
      </div>

      <div class="form-field">
        <div class="password-container">
          <input #inputPassword class="password" type="password"
            placeholder="CPF" aria-label="CPF" formControlName="password">

          <div class="eye_password">
            <img #iconPassword src="assets/images/eye-view.png"
              alt="Ícone de olho para esconder/mostrar a senha"
              (click)="toogleIconPassword()" />
          </div>
        </div>

        @if (submited && loginForm.controls.password.errors?.required) {
          <app-error-form>
            Informe o CPF.
          </app-error-form>
        }
      </div>

      <button class="btn-enter" (click)="login()">
        Acessar
      </button>
    </form>

    <button type="button" class="btn-back-home" (click)="back()">
      <span aria-hidden="true">←</span> Voltar ao início
    </button>
  </section>
</main>
